module.exports = __webpack_public_path__ + "img/Image1.31dd60bf.svg";